import { Link } from 'react-router-dom';
import { categories, categoryVideos } from '@/mocks/categories';

export default function CategoryPreview() {
  const previewVideos = categoryVideos.trending.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium mb-4">
              热门内容
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              探索精彩视频内容
            </h2>
            <p className="text-foreground-600 leading-relaxed">
              涵盖八大内容分类，总有你感兴趣的领域
            </p>
          </div>
          <Link
            to="/category"
            className="px-5 py-2.5 rounded-lg border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览全部分类
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.id}`}
              className="px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {previewVideos.map((video) => (
            <div
              key={video.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/70 transition-all duration-300 hover:translate-y-[-2px] cursor-pointer"
            >
              <div className="relative aspect-[9/16] overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-3">
                <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-1">
                  {video.title}
                </h4>
                <p className="text-xs text-foreground-500">{video.author}</p>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i>
                    {video.likes}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}